export default {
  GET_USER_DATA_FOR_EDIT: 'GET_USER_DATA_FOR_EDIT',
  CHANGED_INPUT_DATA: 'CHANGED_INPUT_DATA',
  TOGGLE_IS_SHOW_CHANGE_EMAIL_MODAL: 'TOGE_IS_SHOW_CHANGE_EMAIL_MODAL',
  TOGGLE_IS_SHOW_CHANGE_PASSWORD_MODAL: 'TOGGLE_IS_SHOW_CHANGE_PASSWORD_MODAL',
  TOGGLE_IS_SHOW_DELETE_USER_ACCOUNT: 'TOGGLE_IS_SHOW_DELETE_USER_ACCOUNT',
  OFF_SUCCESS_UPDATE: 'OFF_SUCCESS_UPDATE',
  EDIT_PROFILE: {
    pending: 'EDIT_PROFILE/pending',
    fulfilled: 'EDIT_PROFILE/fulfilled',
    rejected: 'EDIT_PROFILE/rejected'
  },
  EDIT_USER_EMAIL: {
    pending: 'EDIT_USER_EMAIL/pending',
    fulfilled: 'EDIT_USER_EMAIL/fulfilled',
    rejected: 'EDIT_USER_EMAIL/rejected'
  },
  EDIT_USER_PASSWORD: {
    pending: 'EDIT_USER_PASSWORD/pending',
    fulfilled: 'EDIT_USER_PASSWORD/fulfilled',
    rejected: 'EDIT_USER_PASSWORD/rejected'
  },
  DELETE_USER_ACCOUNT: {
    pending: 'DELETE_USER_ACCOUNT/pending',
    fulfilled: 'DELETE_USER_ACCOUNT/fulfilled',
    rejected: 'DELETE_USER_ACCOUNT/rejected'
  },
}


// WEBPACK FOOTER //
// ./src/app/containers/Profile/ActionTypes.js